import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { RoleBasedSidebar } from "./RoleBasedSidebar";
import { Topbar } from "./Topbar";
import { usePermissions } from "@/hooks/usePermissions";
import { RoutePermissionGuard } from "@/components/auth/RouteGuards";
import { AIAssistantDrawer } from "@/components/ai";

export const OrgLayout = () => {
  const location = useLocation();
  const { isDoorStaff } = usePermissions();
  const [aiAssistantOpen, setAiAssistantOpen] = useState(false);
  
  return (
    <div className="min-h-screen bg-obsidian" data-testid="org-layout">
      <RoleBasedSidebar 
        variant="org" 
        onAIAssistantClick={() => setAiAssistantOpen(true)}
      />
      <Topbar variant="org" />
      <main className="lg:pl-[240px] min-h-[calc(100vh-64px)] pt-16 lg:pt-0">
        <div className={isDoorStaff ? "p-4" : "px-4 py-6 sm:px-6 lg:px-8 lg:py-8"}>
          <RoutePermissionGuard routePath={location.pathname}>
            <Outlet />
          </RoutePermissionGuard>
        </div>
      </main>
      
      {/* AI Assistant Drawer */}
      <AIAssistantDrawer 
        open={aiAssistantOpen} 
        onOpenChange={setAiAssistantOpen}
      />
    </div>
  );
};

export default OrgLayout;
